import { render } from "./top-view-table.vue?vue&type=template&id=d227bace&scoped=true"
import script from "./top-view-table.vue?vue&type=script&lang=ts"
export * from "./top-view-table.vue?vue&type=script&lang=ts"

import "./top-view-table.vue?vue&type=style&index=0&id=d227bace&lang=less"
import "./top-view-table.vue?vue&type=style&index=1&id=d227bace&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d227bace"

export default script